export const mobileWidth = 600;
export const BackOnePage = () => {
  window.history.back();
};
